import React from "react";

export default function VisibilitySection({ children, index, sectionsRef, visibilityStates, className = "" }) {
  return (
    <section ref={(el) => (sectionsRef.current[index] = el)} className={`${className} ${visibilityStates[index] ? "visible" : "hidden"}`}>
      {children}
    </section>
  );
}
